const asString = (value: unknown): string | undefined => (typeof value === "string" ? value : undefined);

const checkEmail = (email?: string): boolean => {
  if (!email) {
    return true;
  }
  // eslint-disable-next-line prefer-named-capture-group, require-unicode-regexp -- ASCII-only regex, groups are not read
  return !!/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.exec(
    email,
  );
};

const checkLink = (link?: string): boolean => {
  if (!link) {
    return true;
  }
  let url;

  try {
    url = new URL(link);
  } catch (_) {
    return false;
  }

  return url.protocol === "http:" || url.protocol === "https:";
};

export const contactsDetailsValidationConfig = {
  contactEmail: {
    rules: [
      {
        check: (value: unknown): boolean => checkEmail(asString(value)),
        message: "Invalid email. ex: yourbusiness@email.com",
      },
    ],
  },
  contactWebsite: {
    rules: [
      {
        check: (value: unknown): boolean => checkLink(asString(value)),
        message: "Invalid link. ex: https://example.com",
      },
    ],
  },
};

export const socialMediaDetailsValidationConfig = {
  instagramLink: {
    rules: [
      {
        check: (value: unknown): boolean => checkLink(asString(value)),
        message: "Invalid link. ex: https://example.com",
      },
    ],
  },
  facebookLink: {
    rules: [
      {
        check: (value: unknown): boolean => checkLink(asString(value)),
        message: "Invalid link. ex: https://example.com",
      },
    ],
  },
  linkedinLink: {
    rules: [
      {
        check: (value: unknown): boolean => checkLink(asString(value)),
        message: "Invalid link. ex: https://example.com",
      },
    ],
  },
};

export const validationConfig = {
  ...contactsDetailsValidationConfig,
  ...socialMediaDetailsValidationConfig,
  paymentLinkDescription: {
    rules: [
      {
        check: (value: unknown): boolean => {
          const text = asString(value);
          return text ? text.length >= 3 : true;
        },
        message: "3 characters or more",
      },
    ],
  },
};

export const validationViewPageConfig = {
  amount: {
    rules: [{ check: (value: unknown): boolean => !!value, message: "Required" }],
  },
  email: {
    rules: [
      {
        check: (value: unknown): boolean => !!value && checkEmail(asString(value)),
        message: "Invalid email. ex: yourbusiness@email.com",
      },
    ],
  },
  name: {
    rules: [{ check: (value: unknown): boolean => (asString(value)?.length ?? 0) >= 3, message: "Required" }],
  },
  description: {
    rules: [{ check: (value: unknown): boolean => (asString(value)?.length ?? 0) >= 3, message: "Required" }],
  },
  agreement: {
    rules: [{ check: (value: unknown): boolean => !!value, message: "Required" }],
  },
};

export const defaultMaxAmount = 100000;
const minAmount = 0.01;

export function validateAmount(maxAmountFromServer?: string, formAmount?: string): "max" | "min" | null {
  const maxAmount = maxAmountFromServer ? Number(maxAmountFromServer) : defaultMaxAmount;

  const amount = Number(formAmount);

  if (amount < minAmount) {
    return "min";
  }

  if (amount > maxAmount) {
    return "max";
  }

  return null;
}
